import React from 'react';
import get from 'lodash/get';
import { wrapCollectionLayout } from "@quintype/components";
import { Link, ResponsiveHeroImage, LoadMoreButton } from '@quintype/components';
import './four-col-grid.module.css'
import {ReviewRating} from "@quintype/components";
import { ImageFallback } from "../basic/image-fallback.js";
import {collectionColor, collectionSection} from './collection-layout-helper';
import { SectionName } from "../basic/section-name.js";
import { altTagOfHeroImages} from "../../utils";

const themeStyles = {
  dark: "theme-dark"
};

function FourColGridBase({collection, stories, associatedMetadata, config, onLoadMore, noMoreStories}) {
  const {theme = 'dark', 
         hide_section = false,
         show_collection_title: collectionName = true,
         limit_stories = 0} = associatedMetadata;

  if(limit_stories)
    stories = stories.slice(0, limit_stories);

  return <div className="component-wrapper">
    {collectionName ? <SectionName hideLink={true} name={collection.name} type="large" section={collectionSection(config, collection)}/> : null}
    <div styleName="stories">
      {stories.map((story, index) => {
        const isReviewStory = story["story-template"] === 'review';
        return <div key={`${index}-${story.id}`}>
          <Link href={`/${story.slug}`}>
             { story["hero-image-s3-key"]  ? <figure styleName="image">
              <ResponsiveHeroImage story={story}
                                   aspectRatio={[16, 9]}
                                   alt={altTagOfHeroImages(story)}
                                   defaultWidth={480}
                                   widths={[250,480,640]} sizes="(max-width: 500px) 98%, (max-width: 768px) 48%, 23%"
                                   imgParams={{auto:['format', 'compress'], fit:'max'}}/>
            </figure> :
            <ImageFallback className="story-card__image story-card__image--cover"/> }
            <div styleName="relative">
              {!hide_section && <div styleName="section-name">
                {story.sections[0]["display-name"] || story.sections[0]["name"]}</div>}
              <h2 styleName={`headline ${themeStyles[theme] || ""}`}>
                <bdi dangerouslySetInnerHTML={{__html:story.headline}}></bdi>
                {isReviewStory && <ReviewRating value={get(story, ['metadata','review-rating', 'value'], '0')} />}
              </h2>
            </div>
          </Link>
        </div>
      })}
    </div>
    { onLoadMore && !noMoreStories && <LoadMoreButton styleName="load-more" onLoadMore={onLoadMore} text='Load more' /> }
  </div>;
}

export const FourColGrid = wrapCollectionLayout(FourColGridBase);
